import { Action } from '@ngrx/store';
import {
      DATETIME_FORMAT_FETCH,
      DATETIME_FORMAT_SET,
      GLOBAL_FETCH,
      GLOBAL_SET, GLOBAL_SETTINGS_FETCH,
      GLOBAL_SETTINGS_SET,
      INDUSTRIES_FETCH,
      INDUSTRIES_SET,
      SESSION_MOMENT_LOCALE_UPDATE,
      TIMEZONES_FETCH,
      TIMEZONES_SET,
      USER_DATETIME_FORMAT_FETCH,
      USER_DATETIME_FORMAT_SET
} from '../action-types';
import { Industry } from '@core/models/common/industry';
import { DatetimeFormat } from '@core/models/common/datetime-format';

export class FetchGlobalAction implements Action {
    readonly type = GLOBAL_FETCH;
}
  
export class SetGlobalAction implements Action {
    readonly type = GLOBAL_SET;
  
    constructor(public payload?: any) {}
  
}
  
// fetch settings from settings.json
export class FetchSettingsAction implements Action {
      readonly type = GLOBAL_SETTINGS_FETCH;
}
  
export class SetSettingsAction implements Action {
      readonly type = GLOBAL_SETTINGS_SET;
  
      constructor(public payload?: any) {}
  
}
  
export class FetchIndustriesAction implements Action {
    readonly type = INDUSTRIES_FETCH;
  
    constructor() {}
}
  
export class SetIndustriesAction implements Action {
    readonly type = INDUSTRIES_SET;
  
    constructor(public payload: {
      industries: Industry[]
    }) {}
}
  
export class FetchTimezonesAction implements Action {
      readonly type = TIMEZONES_FETCH;
}
  
export class SetTimezonesAction implements Action {
      readonly type = TIMEZONES_SET;
      constructor(public payload: {
          timezones: string[]
      }) {}
}
  
export class FetchDatetimeFormatAction implements Action {
      readonly type = DATETIME_FORMAT_FETCH;
}
  
export class SetDatetimeFormatAction implements Action {
      readonly type = DATETIME_FORMAT_SET;
  
      constructor(public payload?: DatetimeFormat[]) {}
}
  
export class FetchUserDatetimeFormatAction implements Action {
      readonly type = USER_DATETIME_FORMAT_FETCH;
}
  
export class SetUserDatetimeFormatAction implements Action {
      readonly type = USER_DATETIME_FORMAT_SET;
  
      constructor(public payload?: any) {}
}

export class UpdateMomentLocaleAction implements Action {
      readonly type = SESSION_MOMENT_LOCALE_UPDATE;
}
